import { Exercise } from '../_models/_generated/Exercise';

export class DashboardState {
  public StateId: number = 1;
  public CurrentExercise: Exercise = null;
  public AllExercises: Exercise[] = null;
}
